import {DataInput} from "../models/DataCollectionPaneConfig";
import {settings} from "../../../../settings/settings-util";
import {VTree, VNode} from "virtual-dom";
import h from "virtual-dom/h";
import {buildLabelText} from "./Label";
import {buildErrorMessages} from "./ErrorMessages";
import {Dictionary} from "../../../../types/rendering";


const buildCharacterCounter = (input: DataInput, passedSettings: typeof settings): VNode[] =>
{
    if (input.multiline !== "true") { return []; }

    const params =
    {
        className: passedSettings.classNames.textAreaCharacterCounter,
        innerHTML: `0/${input.maxLength}`,
        'aria-label': `0/${input.maxLength}`,
    };

    return [h('div', params, [])];
};

const buildTextElement = (input: DataInput, passedSettings: typeof settings, onInput: () => void, onBlur: () => void): VNode =>
{
    const textParams: Dictionary = {
        type: 'text',
        id: input.id,
        defaultValue: input.value,
        placeholder: input.placeholder,
        className: passedSettings.classNames.dataCollectionPaneTextBox,
        maxLength: input.maxLength,
        required: input.required === 'true',
        readonly: !input.id,
        oninput: onInput,
        onblur: onBlur,
    };

    if (input.validation) { textParams.attributes = { pattern: input.validation }; }

    return h(input.multiline === 'true' ? 'textarea' : 'input', textParams, []);
};

const buildTextField = (input: DataInput, dataInputs: DataInput[], passedSettings: typeof settings, onInput: () => void, onBlur: () => void): VTree[] =>
{
    const lastElementID = dataInputs[dataInputs.length - 1].id;
    const labelText = buildLabelText(input, passedSettings.classNames);
    const textElement = buildTextElement(input, passedSettings, onInput, onBlur);
    const errors = buildErrorMessages(input, passedSettings);

    const className = passedSettings.classNames.dataCollectionPaneTextBoxLabel;
    if(input.id === lastElementID)
    {
        const label = h('label', { className }, [...labelText, textElement, errors]);
        return [label, ...buildCharacterCounter(input, passedSettings)];
    }
    else
    {
        const label = h('label', { className }, [...labelText, textElement]);
        return [label, ...buildCharacterCounter(input, passedSettings)];
    }
    
};

export {
    buildTextField,
    buildTextElement,
    buildCharacterCounter
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/elements/TextField.ts